/* global woocommerce_params, script_l10n */

$.fn.AddToCartForm = function (cart) {
  let form = this;

  form.add_to_cart = function (e) {
    /* Block form */
    e.preventDefault();
    $('.product-content').block({
      message: null,
      overlayCSS: {
        'background-color': $('.content-area').css('background-color')
      }
    });

    /* Facebook Pixel event */
    if ('fbq' in window) {
      fbq('track', 'AddToCart');
    }

    /* Prepare data to cart */
    let postdata = {
      quantity: form.find('input[name="quantity"]').val(),
      'add-to-cart': form.find('[name="add-to-cart"]').val(),
      product_id: form.find('[name="add-to-cart"]').val()
    };
    let variation_id = form.find('input[name="variation_id"]').val(),
      pa_frequence = form.find('select[name="attribute_pa_frequence"]').val();
    if (variation_id) {
      postdata.variation_id = variation_id;
    }
    if (pa_frequence) {
      postdata.pa_frequence = pa_frequence;
    }

    /* Post to cart */
    $.post(window.location, postdata, function (x) {
      cart.refreshFragments(x);
    });
  };

  return (function () {
    form.on('submit', form.add_to_cart);
    return form;
  })();
};

$.fn.CartPanel = function (is_checkout) {
  let self = this;
  self.checking_out = false;
  self.has_changed = false;

  self.open = function (e) {
    if (e != undefined) e.preventDefault();
    self.addClass('cart-panel--active');
  };

  self.close = function (e) {
    if (e != undefined) e.preventDefault();
    self.removeClass('cart-panel--active');
  };

  self.refreshFragments = function (x) {
    $.ajax({
      url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments'),
      type: 'POST',
      success: function (response) {
        if (response && response.fragments) {
          /* Replace fragments */
          $.each(response.fragments, function (key, value) {
            $(key).replaceWith(value);
          });

          /* Session storage */
          if ('sessionStorage' in window && window.sessionStorage !== null) {
            sessionStorage.setItem(window.wc_cart_fragments_params.fragment_name, JSON.stringify(response.fragments));
            sessionStorage.setItem(window.wc_cart_fragments_params.cart_hash_key, response.cart_hash);
            sessionStorage.setItem('wc_cart_created', new Date().getTime());
            localStorage.setItem(window.wc_cart_fragments_params.fragment_name, JSON.stringify(response.fragments));
            localStorage.setItem(window.wc_cart_fragments_params.cart_hash_key, response.cart_hash);
            localStorage.setItem('wc_cart_created', new Date().getTime());
          }

          /* Fragments refreshed */
          $(document.body).trigger('wc_fragments_refreshed');
          $('.product-content').unblock();

          /* If is on cart checkout */
          if (self.checking_out) {
            location.href = self.find('.checkout-cart').attr('href');
            return;
          }

          /* If is on add to cart */
          if (x != undefined) {
            if (x.redirection != undefined) {
              location.href = x.redirection;
            } else {
              /* Display success message */
              $('.woocommerce-message').remove();
              $('.woocommerce-notices-wrapper').append($('<html>').html(x).find('.woocommerce-message').css('display', 'flex').hide().fadeIn());
              $('.woocommerce-message')
                .find('.cart-button')
                .on('click', function () {
                  self.open();
                });

              /* Reset quantity */
              $('.summary.entry-summary form.cart input.qty').val(1).change();
            }
          }
        }
      }
    });
  };

  self.checkout = function () {
    if (self.has_changed) {
      self.checking_out = true;
      self.update();
      return false;
    }
  };

  self.update = function (e) {
    if (e != undefined) {
      e.preventDefault();
    }
    $('button[name="woocommerce_checkout_place_order"], #place_order').prop('disabled', true);
    self.find('.update-cart').prop('disabled', true);
    if (is_checkout) {
      $('.checkout-review-panel').block({
        message: null,
        overlayCSS: {
          'background-color': $('.checkout-review-panel').css('background-color')
        }
      });
    } else {
      self.find('.cart-panel__wrapper').block({
        message: null,
        overlayCSS: {
          'background-color': self.find('.cart-panel__content').css('background-color')
        }
      });
    }

    let quantities = {},
      subscriptions = {},
      frequence = $('select[name="frequence"]').val(),
      promo = '';
    self.find('.cart-item').each(function (index, product) {
      if ($(product).hasClass('promo-item')) {
        promo = $('select[name="promo_item"]').val();
      } else if ($(product).data('cart-item')) {
        let quantity = parseInt($(product).find('.qty').val()),
          is_subscription = $(product).find('input[name="is_subscription"]').prop('checked') ? 1 : 0;
        if (isNaN(quantity)) {
          quantity = 0;
        }
        if ($(this).hasClass('to-remove')) {
          quantity = 0;
        } else if (quantity < 1 && !$(product).hasClass('promo-item')) {
          $(product).addClass('to-remove');
          quantity = 0;
        }
        quantities[$(product).data('cart-item')] = quantity;
        subscriptions[$(product).data('cart-item')] = is_subscription;
      }
    });

    $.post(
      woocommerce_params.ajax_url,
      {
        action: 'update_cart_quantities',
        quantities: quantities,
        subscriptions: subscriptions,
        frequence: frequence,
        promo: promo,
        is_checkout: is_checkout
      },
      function (response) {
        self.find('.woocommerce-mini-cart__total.total .woocommerce-Price-amount.amount').replaceWith(response.subtotal);
        for (let cart_item_key in response.prices) {
          let newPrice = $(response.prices[cart_item_key]);
          self
            .find('.cart-item[data-cart-item="' + cart_item_key + '"]')
            .find('.woocommerce-Price-amount.amount')
            .replaceWith(newPrice);
        }
        $('.cart-count').text(response.count).removeClass('cart-count--visible cart-count--hidden');
        if (response.count < 1) {
          $('.cart-count').text('');
          $('.cart-count').addClass(response.plan ? 'cart-count--visible' : 'cart-count--hidden');
          if (is_checkout) {
            location.href = script_l10n.URL_SHOP;
            return;
          }
        } else if (response.count > 99) {
          $('.cart-count').addClass('cart-count--visible');
        }
        $('.to-remove').slideUp(200, function () {
          $(this).remove();
        });

        if (!is_checkout && self.checking_out) {
          self.refreshFragments();
        } else {
          self.has_changed = false;
          if (is_checkout) {
            $(document.body).on('updated_checkout', function () {
              $('.checkout-review-panel').unblock();
              $('button[name="woocommerce_checkout_place_order"], #place_order').prop('disabled', false);
              $(document.body).off('updated_checkout');
            });
            $(document.body).trigger('update_checkout');
            self.refreshFragments();
          } else {
            self.find('.cart-panel__wrapper').unblock();
            self.refreshFragments();
          }
        }
      },
      'json'
    );
  };

  self.initialize = function () {
    /* Increment fields */
    self.find('.qty').each(function () {
      const incrementField = $(this).IncrementField();
      incrementField.on('change', function () {
        if (is_checkout) {
          self.update();
        } else {
          self.has_changed = true;
          self.find('.update-cart').prop('disabled', false);
        }
      });
    });

    self
      .find('select[name="promo_item"]')
      .off('change')
      .on('change', function () {
        if (is_checkout) {
          self.update();
        } else {
          self.has_changed = true;
          self.find('.update-cart').prop('disabled', false);
        }
      });

    self
      .find('input[name="is_subscription"]')
      .off('change')
      .on('change', function () {
        if (is_checkout) {
          if (self.find('input[name="is_subscription"]:checked').length) {
            $('.checkout-controls').addClass('visible');
          } else {
            $('.checkout-controls').removeClass('visible');
          }
          self.update();
        } else {
          self.has_changed = true;
          self.find('.update-cart').prop('disabled', false);
        }
      });

    self
      .find('select[name="frequence"]')
      .off('change')
      .on('change', function () {
        if (is_checkout) {
          self.update();
        } else {
          self.has_changed = true;
          self.find('.update-cart').prop('disabled', false);
        }
      });

    /* Update button */
    self.off('click', '.update-cart', self.update).on('click', '.update-cart', self.update);
    self.find('.checkout-cart').on('click', self.checkout).data('preventTransition', 1);

    /* Remove links */
    self.find('.product_list_widget .row').unblock();
    self
      .find('.remove_from_cart_button')
      .on('click', function (e) {
        e.preventDefault();
        $(this).closest('.cart-item').addClass('to-remove');
        self.update();
      })
      .data('preventTransition', 1);
  };

  return (function () {
    $('.cart-button').on('click', self.open);
    $('.cart-panel__close-btn').on('click', self.close);
    $('.cart-panel__shop-link').on('click', function (e) {
      if ($('body').hasClass('woocommerce-shop')) {
        e.preventDefault();
      }
      self.close();
    });
    $(document).on('click', function (e) {
      if (!$(e.target).hasClass('cart-button') && $(e.target).parents('.cart-panel').length === 0 && $(e.target).parents('.cart-button').length === 0) {
        self.close();
      }
    });
    if (is_checkout) {
      $('.woocommerce-form-coupon-container').prepend($('.checkout_coupon.woocommerce-form-coupon').show());
    }
    $(document.body).off('wc_fragments_refreshed', self.initialize).on('wc_fragments_refreshed', self.initialize);
    $(document.body).off('removed_from_cart', self.initialize).on('removed_from_cart', self.initialize);
    self.initialize();
    return self;
  })();
};

let cart = undefined;

export default {
  init() {
    cart = $('.cart-panel').CartPanel(false);
    $('.checkout-review-panel').CartPanel(true);
    $('.product-content form.cart').each(function () {
      $(this).AddToCartForm(cart);
    });
  },

  open() {
    if (cart != undefined) {
      cart.open();
    }
  },

  close() {
    if (cart != undefined) {
      cart.close();
    }
  },

  refresh(x) {
    if (cart != undefined) {
      cart.refreshFragments(x);
    }
  }
};
